import React, { useRef, useState } from "react";
import { uploadFileHttp } from "../../../http";
import styles from "../styles/ChatbotWindow.module.css";

interface Props {
  beneficiaryId: string;
  onUpload: (url: string) => void;
}

const InsuranceUpload: React.FC<Props> = ({ beneficiaryId, onUpload }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError("");
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("benId", beneficiaryId);
      formData.append("docType", "insurance");
      formData.append("docName", file.name);
      const res = await uploadFileHttp(formData);
      const url = res?.data?.data?.url;
      if (!url) throw new Error("No URL returned");
      onUpload(url);
    } catch {
      setError("Upload failed. Please try again.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className={styles.imageUpload}>
      <button className={styles.uploadBtn} onClick={() => inputRef.current?.click()} disabled={uploading}>
        {uploading ? "Uploading..." : "📎 Upload Insurance Document"}
      </button>
      {error && <span className={styles.uploadError}>{error}</span>}
      <input ref={inputRef} type="file" accept=".pdf,.zip,.jpeg,.png,.jpg" style={{ display: "none" }} onChange={handleFile} />
    </div>
  );
};

export default InsuranceUpload;
